import React, { useEffect, useState } from "react";

import { Stack } from "@mui/material";
import { Chart } from "components/reports/Chart/Chart";
import { useActionHook } from "hooks";
import { useDealQueriesSelect, useReportsActions, useReportsQueriesSelector } from "store";

import { DateRangeValue } from "../../../store/types";
import { SelectDateRange } from "../../forms";
import { DependentTable } from "./DependentTable";
import { Filters } from "./Filters";
import { KPIs } from "./KPIs";
import { MainTable } from "./MainTable";
import { Rounds } from "./Rounds";
import { StyledStack } from "./StyledStack";

export const Dashboard: React.FC = () => {
  const [selectedDealName, setSelectedDealName] = useState<string>("");
  const [selectDateRange, setSelectedDateRange] = useState<DateRangeValue>({ value: "fromInception" });
  const { filters, chartInvestorView } = useDealQueriesSelect();
  const [name, dataFormation] = Object.entries(chartInvestorView)[0];
  const { currency, exchangeMethod, dateRange } = useReportsQueriesSelector();
  const { getBulkPieChartsAction } = useReportsActions();

  const { data: chartData, action: fetchChart, loading: chartLoading } = useActionHook(getBulkPieChartsAction);

  useEffect(() => {
    fetchChart({
      filters,
      graphDataFormation: chartInvestorView,
      dateRange,
      currency,
      exchangeMethod,
      use_accounting_date: false
    });
  }, [filters, dateRange, chartInvestorView, currency, exchangeMethod]);

  return (
    <>
      <Stack sx={{ gap: "16px", width: "100%", p: "1px", overflow: "auto" }}>
        <StyledStack sx={{ flexDirection: "row", gap: "20px", alignItems: "center", justifyContent: "space-between" }}>
          <Filters />
          <SelectDateRange value={selectDateRange} onChange={setSelectedDateRange} />
        </StyledStack>
        <Stack sx={{ flexDirection: "row", gap: "20px", maxHeight: 228, minHeight: 228 }}>
          <KPIs internalDateRange={selectDateRange} />
          <Chart
            key={name}
            name={name}
            chartSettings={{
              measure: dataFormation.measure,
              groupBy: dataFormation.groupBy,
              chartType: dataFormation.chartType,
              xAxis: dataFormation.xAxis,
              yAxis: dataFormation.yAxis
            }}
            investorsDashboard
            filters={filters}
            pageType="chartInvestorView"
            internalDateRange={selectDateRange}
            data={chartData?.[name]}
            isLoading={chartLoading}
          />
        </Stack>
        <Stack sx={{ flexDirection: "row", gap: "20px", overflow: "hidden", p: "1px", maxHeight: 256, minHeight: 256 }}>
          <MainTable
            selectedDealName={selectedDealName}
            selectDateRange={selectDateRange}
            setSelectedDealName={setSelectedDealName}
          />
          <Rounds internalDateRange={selectDateRange} />
        </Stack>
        <DependentTable selectedDealName={selectedDealName} internalDateRange={selectDateRange} />
      </Stack>
    </>
  );
};
